const AUTH_RUNTIME_ROUTE_PATTERNS = [
  /^\/login(?:\/|$)/i,
  /^\/signin(?:\/|$)/i,
  /^\/callback(?:\/|$)/i,
  /^\/manage-booking(?:\/|$)/i,
  /^\/admin(?:\/|$)/i,
  /^\/settings(?:\/|$)/i,
  /^\/profile(?:\/|$)/i,
  /^\/dashboard(?:\/|$)/i,
  /^\/tenant(?:\/|$)/i,
];

const AUTH0_STORAGE_KEY_PATTERN = /auth0|@@auth0spajs@@/i;
const EMPTY_STORAGE_VALUES = new Set(['', 'null', 'undefined']);

export const hasCachedAuth0Session = (storage) => {
  if (!storage || typeof storage.length !== 'number' || typeof storage.key !== 'function') {
    return false;
  }

  try {
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (!key || !AUTH0_STORAGE_KEY_PATTERN.test(key)) {
        continue;
      }

      const value = storage.getItem(key);
      if (!EMPTY_STORAGE_VALUES.has(String(value ?? '').trim())) {
        return true;
      }
    }
  } catch (_error) {
    return false;
  }

  return false;
};

export const shouldEnableAuthRuntime = (
  pathname = '',
  _storage = typeof window !== 'undefined' ? window.localStorage : null
) => (
  AUTH_RUNTIME_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname))
);

export { AUTH_RUNTIME_ROUTE_PATTERNS };
